import React, { Component } from 'react';
import { List, Avatar, message, Input, Button, Tag, Menu, Dropdown } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import TicketModal from '../../components/modals/public/TicketModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const Search = Input.Search;
const SubMenu = Menu.SubMenu;

class Tickets extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {title: '', body: ''};
    this.state = {redirect: false, tickets: [], filteredTickets: [], ticketModal: false};
    this.validateToken = this.validateToken.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.getTickets = this.getTickets.bind(this);
    this.ticketMenu = this.ticketMenu.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getTickets();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});

    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or gerente or empleado or guardia"))
      this.setState({redirect: true});
  }

  getTickets() {
    let url = `${Configuration.apiServer}/api/v1/tickets-employee`;

    axios.get(url, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');
      
      this.setState({tickets: resp.data, filteredTickets: resp.data});
    });
  }

  handleStatus(ticket) {
    axios.put(`${Configuration.apiServer}/api/v1/tickets/${ticket.id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      message.success('Registro actualizado');
      this.getTickets();
    });
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/tickets`, {ticket: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      message.success('Registro creado');
      this.handleCloseModal();
      this.getTickets();
    });
  }

  handleSearch(event) {
    const tickets = this.state.tickets.filter(ticket => {
      return ticket.titile.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1 || ticket.body.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredTickets: tickets});
  }

  handleOpenModal() {
    this.setState({ticketModal: true});
  }

  handleCloseModal() {
    this.setState({ticketModal: false});
  }

  ticketMenu(ticket) {
    let submenus = [<Menu.Item key="ticket:show"><a href={`/support/tickets/${ticket.id}`}>Ver ticket</a></Menu.Item>];

    // eslint-disable-next-line
    if(parseInt(localStorage.getItem('visitapp:id')) === parseInt(ticket.profile.id)) {
      let status = 'Re abrir';

      if(ticket.status === false)
        status = 'Concluir';

      submenus.push(
        <SubMenu title="Gestión" key="ticket:authorization">
          <Menu.Item><span onClick={ () => { this.handleStatus(ticket) } }>{status}</span></Menu.Item>
        </SubMenu>
      );
    }

    return (<Menu>{submenus}</Menu>);
  }
 
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    return (
      <div>
        <PublicMenu />

        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Tickets de soporte</h3>

            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%'}} />
          </div>

          <br/> <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <List
              className="demo-loadmore-list"
              itemLayout="vertical"
              style={{ width: '100%' }}
              dataSource={this.state.filteredTickets}
              renderItem={ticket => (
                <List.Item>
                  <div className="d-flex align-items-center justify-content-between">
                    <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                    
                    <div style={{ width: '90%' }}>
                      <h6 className="d-flex justify-content-between align-items-center" style={{ marginBottom: '0px' }}>
                        <span>{ticket.titile}</span> 
                        <div>
                          <Tag color="cyan">{Configuration.formatDatetime(ticket.created_at)}</Tag>
                          <Tag color={Configuration.getBadgeStatus(ticket.status).color}>{Configuration.getBadgeStatus(ticket.status).text}</Tag>
                        </div>
                      </h6>
                      <p style={{ marginBottom: '0px' }}>
                        <span style={{ marginRight: '10px' }}>Folio: #{ticket.folio}</span>
                        <span>Detalles: {(ticket.body) ? ticket.body : 'Sin detalles'}</span>
                      </p>
                    </div>

                    <Dropdown overlay={this.ticketMenu(ticket)}>
                      <span className="ant-dropdown-link">
                        <Button icon="ellipsis" shape="circle" style={{ background: '#eee' }} />
                      </span>
                    </Dropdown>
                  </div>
                </List.Item>
              )}
            />
          </div>
        </div>
          
        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />
        <TicketModal visible={this.state.ticketModal} current={this.schema} title="Nuevo ticket de soporte" handleClose={this.handleCloseModal} handleSave={this.handleCreate}  />
      </div>
    );
  }
}

export default Tickets;



// WEBPACK FOOTER //
// ./src/pages/public/Tickets.js